import { useState, useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import AppContext from '../App.context';

export function useEliteHeader() {
  const { eventId = 0 } = useParams();
  const {
    adminProperties: admin = {},
    accountProperties: account = {},
    globalSettingsLoaded,
    clientId,
  } = useContext(AppContext);
  const [isCommonEliteNavLoaded, setIsCommonEliteNavLoaded] = useState(false);
  const {
    adminProperties = {
      adminName: '',
      adminEmail: '',
      isProducerLogin: false,
      isManageUsersReadOnlyPermitted: false,
      wccOrionHost: '',
      segmentsHost: '',
      zendeskScriptUrl: '',
    },
  } = admin;
  const {
    accountProperties = {
      supportLinkUrl: '',
    },
  } = account;
  const {
    adminEmail,
    adminName,
    adminLanguage,
    isManageUsersReadOnlyPermitted,
    isProducerLogin,
    skillJarUrl,
    wccOrionHost,
    segmentsHost,
    zendeskScriptUrl,
    isCustomFontsHidden,
    wccHost,
  } = adminProperties;
  const {
    accountType,
    supportLinkUrl,
    isNylasScheduleEnabled,
  } = accountProperties;
  function initHeader() {
    if (globalSettingsLoaded) {
      window.eventId = eventId;
      window.clientId = clientId;
      window.supportLinkUrl = supportLinkUrl || '';
      window.adminName = adminName;
      window.adminEmail = adminEmail;
      window.adminLanguage = adminLanguage;
      window.wccHost = wccHost;
      window.isProducerLogin = isProducerLogin ? 'true' : 'false';
      window.isManageUsersReadOnlyPermitted = isManageUsersReadOnlyPermitted ? 'true' : 'false';
      window.wccOrionHost = wccOrionHost;
      window.segmentsHost = segmentsHost;
      window.zendeskScriptUrl = zendeskScriptUrl;
      window.isCustomFontsHidden = isCustomFontsHidden;
      window.skillJarUrl = skillJarUrl;
      window.isNylasScheduleEnabled = isNylasScheduleEnabled;
      window.accountType = accountType;

      setIsCommonEliteNavLoaded(true);
    }
  }
  useEffect(() => {
    initHeader();
  }, [eventId, globalSettingsLoaded]);
  return {
    isCommonEliteNavLoaded,
  };
}
